module.exports = __webpack_public_path__ + "img/customer-data.783e6d16.png";